// extracted by mini-css-extract-plugin
export default {"container":"RolesInnerLayout1_container__Q5ms5"};